import React from 'react'
import './not-found.scss'

export default function NotFound(props) {
  return <div className="page page-not-found">Ups, esta página no existe.</div>
}
